const colorMap = new Map([
  ["Black", "#000000"],
  ["Tan", "#D2B48C"],
  ["Brown", "#a52a2a"],
  ["White", "#ffffff"],
  ["Pink", "#ffc0cb"],
  ["Copper", "#b87333"],
  ["Blue", "#0074d9"],
  ["Maroon", "#800000"],
  ["Purple", "#800080"],
  ["Olive Green", "#3c341f"],
  ["Red", "#f80004"],
  ["Grey", "#808080"],
  ["Golden", "#d4af37"],
  ["Beige", "#F5F5DC"],
  ["Peach", "#ffe5b4"],
  ["Navy Blue", "#000080"],
  ["Cream", "#FFFDD0"],
  ["Green", "#008000"],
  ["Silver", "#c0c0c0"],
  ["Yellow", "#ffef2e"],
  ["Orange", "#ffa600"],
  ["Sky Blue", "#87CEEB"],
  ["Cherry", "#B62625"],
  ["Voilet", "#8F00FF"],
  ["Sea Blue", "#006994"],
  ["Lemon", "#fff700"],
]);
var addCollectionSorting = (filter) => {
  let isJson = false,
    isSortJson = false;
  typeof filter == "string" && ((isJson = true), (filter = JSON.parse(filter))),
    typeof filter.sort == "string" &&
      ((isSortJson = true), (filter.sort = JSON.parse(filter.sort)));
  let newSort = [];
  if (filter.sort[0].field === "product_wizzy-best-selling_sortOrder:float") {
    newSort = filter.sort.filter(
      (item) => item.field !== "product_wizzy-best-selling_sortOrder:float"
    );
  } else {
    newSort = filter.sort;
  }
  console.log(newSort);

  (filter.sort = newSort),
    isSortJson && (filter.sort = JSON.stringify(filter.sort)),
    isJson && (filter = JSON.stringify(filter));
};

function createViewMoreBtn(itemsToShowCount, element, facetItems, viewMoreBtn) {
  viewMoreBtn.style.display = "flex";

  const initialItemsToShow = itemsToShowCount;
  let itemsToShow = initialItemsToShow;

  // Function to update the visibility of list items
  const updateVisibility = () => {
    facetItems.forEach((item, index) => {
      // console.log(index)
      if (index >= itemsToShow) {
        item.classList.add("visible");
      } else {
        item.classList.remove("visible");
      }
    });
  };
  // Initially show only the first 5 items
  updateVisibility();

  viewMoreBtn.addEventListener("click", () => {
    itemsToShow += initialItemsToShow;
    updateVisibility();
    // Show the View Less button when more items are shown
    // viewLessBtn.style.display = "inline";
    // Hide the View More button if all items are visible
    if (itemsToShow >= facetItems.length) {
      viewMoreBtn.style.display = "none";
    }
  });
}


const customSortForQueries = ["kids shoes", "kid shoes", "kid shoe", "women slippers","women slipper","women's slippers","women's slipper",
  "womenslipper", "men slippers","men slipper","men's slippers","men's slipper","menslipper","menslippers", "women shoes","women shoe"];

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      // console.log("==================inside",data);
      data.common.lazyDOMConfig.searchInputIdentifiers[0].dom = "header input";
      data.common.lazyDOMConfig.searchInputIdentifiers[0].type = "text";

      /*for grid filters - starts here*/
      data["search"]["view"]["templates"]["facets"]["gridFilterCommon"] =
        "#wizzy-grid-facet-block";
      data["gridFilters"] = {
        enabled: true,
        filters: [
          { key: "sizes", question: "Filter for Size", after: { mobile: 6 } },
        ],
      };
      /*for grid filters - ends here*/
      data.filters.configs.keepOpenedInMobileAfterApply = true;

      (window.wizzyConfig.search.view.templates.facets.rangeListItem =
        "#wizzy-facet-range-list-item"),
        window.wizzyConfig.search.configs.facets.configs.push({
          label: "Price",
          buckets: [
            {
              from: 0,
              to: 500,
            },
            {
              from: 500,
              to: 1000,
            },
            {
              from: 1000,
              to: 2500,
            },
            {
              from: 2500,
              to: 5000,
            },
            {
              from: 5000,
              to: 10000,
            },
            {
              from: 10000,
            },
          ],
          key: "sellingPrice",
          position: "left",
          order: 6,
        });

        window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
            desktop: 5000,
            mobile: 3000
        };
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log("VIEW_RENDERED");

      $(".heading-txt")
        .off("click")
        .on("click", function () {
          $(this).toggleClass("active");
          $(this).parent().find(".descp-txt").slideToggle(280);
        });

      /*code for activated link on collection page - starts here*/
      var links = document.querySelectorAll(".clp-catg-tile a");
      // Get the current URL
      var currentURL = window.location.href;
      // Iterate over each anchor tag
      links.forEach(function (link) {
        // Check if the href attribute matches the current URL
        if (link.href === currentURL) {
          // Add the active class to the anchor tag
          link.classList.add("active");
        }
      });
      /*code for activated link on collection page - ends here*/

      /*show no of count for applied filters - starts here*/
      var activeFilterCount1 = 0;
      $(".wizzy-filters-facet-block").each((index, element) => {
        $(element)
          .find(".wizzy-facet-body .wizzy-facet-list .active")
          .each((i, ele) => {
            // console.log(ele);
            activeFilterCount1++;
          });
      });
      activeFilterCount1 > 0 &&
        $(".wizzy-filters-mobile-entry .wizzy-filter-mobile-count b").html(
          activeFilterCount1
        );
      /*show no of count for applied filters - ends here*/

      /*total number of count of collection products - starts here*/
      if (window.wizzyConfig.common.isOnCategoryPage) {
        const collectionHeader = document.querySelector(
          ".page_collection_heading .t4s-page-section-heading .t4s-page-head .t4s-title-head .wizzy-collection-count"
        );
        if (data.data.response.payload.filters.type === "NO_RESULTS_FOUND") {
          collectionHeader.textContent = 0 + " Choices";
        } else {
          collectionHeader.textContent =
            data.data.response.payload.total + " Choices";
        }
      }
      /*total number of count of collection products - ends here*/

      data.data.response.payload.facets.forEach((facet) => {
        /*view more button - starts here*/
        if (
          facet.data.length > 5 &&
          facet.key !== "sizes" &&
          facet.key != "product_Color"
        ) {
          const element = document.querySelector(
            '[data-key="' + facet.key + '"]'
          );
          const facetItems = element.querySelectorAll(
            ".wizzy-facet-body .wizzy-facet-list li"
          );
          const viewMoreBtn = element.querySelector(".wizzy-view-more-btn");

          createViewMoreBtn(5, element, facetItems, viewMoreBtn);
        } else {
          if (facet.data.length > 12) {
            const element = document.querySelector(
              '[data-key="' + facet.key + '"]'
            );
            const facetItems = element.querySelectorAll(
              ".wizzy-facet-body .wizzy-facet-list li"
            );
            const viewMoreBtn = element.querySelector(".wizzy-view-more-btn");

            createViewMoreBtn(12, element, facetItems, viewMoreBtn);
          }
        }
      });
      /*view more button - ends here*/

      setTimeout(function () {
        const swiperContainers = document.querySelectorAll(".mySwiper");
        // console.log(swiperContainers);
        swiperContainers.forEach((container) => {
          let swiperInstance = null;

          container.addEventListener("mouseover", () => {
            if (!swiperInstance) {
              swiperInstance = new Swiper(container, {
                loop: true,
                speed: 600,
                autoplay: {
                  delay: 100,
                  disableOnInteraction: false,
                },
              });
            } else {
              swiperInstance.autoplay.start();
            }
          });

          container.addEventListener("mouseleave", () => {
            if (swiperInstance) {
              swiperInstance.autoplay.stop();
              swiperInstance.slideTo(0, 1000);
            }
          });
        });
      }, 300);

      return data;
    }
  );

  // window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents.EMPTY_RESULTS_RENDERED,
  //    function (data) {

  //      const swiperContainers = document.querySelectorAll('.mySwiper');
  //      console.log(swiperContainers)
  //      swiperContainers.forEach(container => {

  //        let swiperInstance = null;

  //        container.addEventListener('mouseover', () => {
  //          console.log("mouseover")
  //          if (!swiperInstance) {
  //            swiperInstance = new Swiper(container, {
  //              loop: true,
  //              speed: 600,
  //              autoplay: {
  //                delay: 100,
  //                disableOnInteraction: false,
  //              },
  //            });
  //          } else {
  //            swiperInstance.autoplay.start();
  //          }
  //        });

  //        container.addEventListener('mouseleave', () => {
  //          if (swiperInstance) {
  //            swiperInstance.autoplay.stop();
  //            swiperInstance.slideTo(0,1000);
  //          }
  //        });
  //      });

  //      return data;
  //    })

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      /*for swiper on image 404 page - starts here*/
      // const swiperContainers = document.querySelectorAll('.mySwiper');
      // swiperContainers.forEach(container => {

      //   let swiperInstance = null;

      //   container.addEventListener('mouseover', () => {
      //     console.log("mouseover")
      //     if (!swiperInstance) {
      //       swiperInstance = new Swiper(container, {
      //         loop: true,
      //         speed: 600,
      //         autoplay: {
      //           delay: 100,
      //           disableOnInteraction: false,
      //         },
      //       });
      //     } else {
      //       swiperInstance.autoplay.start();
      //     }
      //   });

      //   container.addEventListener('mouseleave', () => {
      //     if (swiperInstance) {
      //       swiperInstance.autoplay.stop();
      //       swiperInstance.slideTo(0,1000);
      //     }
      //   });
      // });
      /*for swiper on image 404 page - ends here*/

      try {
        
        data.forEach((product) => {
          if (product.url) {
            const questionMarkIndex = product.url.indexOf("?");
            product.url =
              questionMarkIndex !== -1
                ? product.url.slice(0, questionMarkIndex)
                : product.url;
          }
  
          product.attributes.forEach((attr) => {
          if (attr.id === "product_badge_judgeme") {
            const reviewHtml = attr?.values?.[0]?.value?.[0];
  
            if (reviewHtml) {
              const divElement = document.createElement("div");
              divElement.innerHTML = reviewHtml;
  
              const jdgmPrevBadge = divElement.querySelector(".jdgm-prev-badge");
  
              if (jdgmPrevBadge) {
              const averageRating = parseFloat(
                jdgmPrevBadge.getAttribute("data-average-rating") || 0
              );
  
              const reviews = parseInt(
                jdgmPrevBadge.getAttribute("data-number-of-reviews") || 0,
                10
              );
  
              const rating = averageRating.toFixed(1);
  
              // Render if there are reviews OR a rating
              if (reviews > 0) {
                product.judgemeBadgeHtml = `
                  <div class="nms-product-card__reviews">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      fill="none"
                      width="16"
                      class="nms-icon nms-icon--filled-star"
                      viewBox="0 0 21 21"
                    >
                      <path d="M18.8203 9.44945L15.2969 12.5245L16.3524 17.1026C16.4082 17.3419 16.3923 17.5924 16.3065 17.8227C16.2208 18.053 16.0691 18.253 15.8703 18.3975C15.6716 18.5421 15.4346 18.6249 15.1891 18.6355C14.9436 18.6461 14.7004 18.5841 14.4899 18.4573L10.4969 16.0354L6.51252 18.4573C6.30202 18.5841 6.05881 18.6461 5.81328 18.6355C5.56775 18.6249 5.33079 18.5421 5.13204 18.3975C4.9333 18.253 4.78157 18.053 4.69584 17.8227C4.6101 17.5924 4.59416 17.3419 4.65002 17.1026L5.70392 12.5291L2.1797 9.44945C1.99331 9.28869 1.85852 9.07647 1.79225 8.83941C1.72598 8.60235 1.73117 8.351 1.80718 8.11688C1.88319 7.88276 2.02663 7.6763 2.21952 7.52337C2.4124 7.37045 2.64614 7.27788 2.89142 7.25727L7.53674 6.85492L9.35002 2.52992C9.44471 2.30298 9.60443 2.10913 9.80907 1.97278C10.0137 1.83643 10.2541 1.76367 10.5 1.76367C10.7459 1.76367 10.9863 1.83643 11.191 1.97278C11.3956 2.10913 11.5553 2.30298 11.65 2.52992L13.4688 6.85492L18.1125 7.25727C18.3578 7.27788 18.5915 7.37045 18.7844 7.52337C18.9773 7.6763 19.1207 7.88276 19.1968 8.11688C19.2728 8.351 19.278 8.60235 19.2117 8.83941C19.1454 9.07647 19.0106 9.28869 18.8242 9.44945H18.8203Z"
                        fill="#e2000f"
                        style="opacity:0.5;"
                      />
                    </svg>
  
                    <span class="review-rating">${rating}</span>
                    <span>|</span>
                    <span class="review-count">(${Math.min(reviews, 10)})</span>
                  </div>
                `;
              }
              }
            }
          }
            if (attr.id === "product_tags") {
              product.newArrival =
                attr.values[0].value[0].includes("New Arrivals");
            }
          });
  
          product.sellingPrice = product.sellingPrice.split(".")[0];
          product.price = product.price.split(".")[0];
        });
  
        data.forEach((product) => {
          product.newArrival = false;
          product.bestSeller = false;
          product.newDrops = false;
          product.trendings = false;
          product.crazyDeals = false;
          product.handle = false;
          if (product.attributes) {
            product.attributes.forEach((attribute) => {
              if(attribute.id === "product_handle") {
                product.handle = attribute.values[0].value[0];
              }
              if (attribute.id === "product_tags") {
                if (attribute.values[0].value[0].length > 0) {
                  // if(attribute.values[0].value[0].includes("New Arrivals")) {
                  //   product.newArrival = true;
                  // }
                  // if(attribute.values[0].value[0].includes("new_drops") && !product.newArrival) {
                  //   product.newDrops = true;
                  // }
                  // if(attribute.values[0].value[0].includes("Trending") && !product.newArrival && !product.newDrops) {
                  //   product.trendings = true;
                  // }
                  // if(attribute.values[0].value[0].includes("crazy_deal") && !product.newArrival && !product.newDrops && !product.trendings) {
                  //   product.crazyDeals = true;
                  // }
  
                  if (attribute.values[0].value[0].includes("crazy_deal")) {
                    product.crazyDeals = true;
                  }
                  if (
                    attribute.values[0].value[0].includes("Trending") &&
                    !product.crazyDeals
                  ) {
                    product.trendings = true;
                  }
                  if (
                    attribute.values[0].value[0].includes("new_arrival") &&
                    !product.crazyDeals &&
                    !product.trendings
                  ) {
                    product.newDrops = true;
                  }
                  if (
                    attribute.values[0].value[0].includes("New Arrivals") &&
                    !product.crazyDeals &&
                    !product.trendings
                  ) {
                    product.newArrival = true;
                  }
                    if (
                      attribute.values[0].value[0].includes("best_seller") &&
                      !product.crazyDeals &&
                      !product.trendings &&
                      !product.newArrival
                  ) {
                   product.bestSeller = true;
                 }
                }
              }
            });
          }
  
          if (wizzyConfig.common.isOnCategoryPage) {
            product.currentColletionEndpoint = window.wizzyConfig.common.categoryEndpoint;
            product.url = `${product.currentColletionEndpoint}` + '/products/' + `${product.handle}`;
          }
  
  
        });
      } catch (error) {
        console.log("error",error);
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log("=====>BEFORE_AUTOCOMPLETE_EXECUTED",payload);

      payload.sort = [
        {
        field: "product_wizzy-best-selling_sortOrder:float",
        order: "asc"
        },
        {
          field: "product_value_tags_gender",
          order: "asc",
        },
      ];

      if(customSortForQueries.includes(payload.q.toLowerCase())){
        payload.sort = [
          {
            field: "relevance",
            order: "asc",
          }
        ];
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      // console.log("===>BEFORE_SEARCH_EXECUTED",payload);

      if(customSortForQueries.includes(payload.q.toLowerCase())){
        payload.sort = [
          {
            field: "relevance",
            order: "asc",
          }
        ];
      }

      payload.sort.push({
        field: "product_value_tags_gender",
        order: "asc",
      });

      // payload.sort = [{
      //   "field" : "product_value_tags_gender",
      //   "order" : "asc"
      // }]

      const collectionHeading = document.querySelector(
        ".page_collection_heading"
      );
      if (collectionHeading) {
        // console.log(collectionHeading)
        collectionHeading.classList.add("wizzy-hide-collection-heading");
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      // console.log("===========>BEFORE_FILTERS_EXECUTED",payload)

      if (!wizzyConfig.common.isOnCategoryPage) {
        payload.filters.sort.push({
          field: "product_value_tags_gender",
          order: "asc",
        });
      }
      if (wizzyConfig.common.isOnCategoryPage) {
        addCollectionSorting(payload.filters);
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload.response.payload.facets;
        // console.log(facets)
        /*eleminate facet for single option in gender filter - starts here*/
        // let facets = data.data.response.payload.facets;
        var index = -1;
        for (var i = 0; i < facets.length; i++) {
          if (
            facets[i].key === "product_value_tags_gender" &&
            facets[i].data.length == 1
          ) {
            var index = i;
            break;
          }
        }
        if (index !== -1) {
          payload.response.payload.facets.splice(index, 1);
        }
        /*eleminate facet for single option in gender filter - ends here*/

        facets.forEach((facet) => {
          if (facet.key === "sizes") {
            facet.data.sort((a, b) => {
              return parseInt(a.key) - parseInt(b.key);
            });
            facet.order = 0;
          }
          if (facet.key === "product_Color") {
            facet.data.forEach((item) => {
              (item.isSwatch = !0),
                (item.isVisualSwatch = !0),
                (item.swatchValue = colorMap.has(item.key)
                  ? colorMap.get(item.key)
                  : "#fff"),
                (item.data = {
                  value: colorMap.get(item.key),
                  swatch: {
                    type: "visual",
                    value: colorMap.get(item.key),
                  },
                });
            });
          }
          /*eleminate facet data with 0 count in price filter - starts here*/
          if (facet.key === "sellingPrice") {
            var priceFacetData = facet.data;

            for (var i = priceFacetData.length - 1; i >= 0; i--) {
              if (priceFacetData[i].count == 0) {
                facet.data.splice(i, 1);
              }
            }
          }
          /*eleminate facet data with 0 count in price filter - ends here*/
        });
      }
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
      const wizzyData = JSON.parse(sessionStorage.getItem("wizzy_store"));

      if (window.wizzyConfig.common.isOnCategoryPage) {
        const collectionHeader = document.querySelector(
          ".page_collection_heading .t4s-page-section-heading .t4s-page-head .t4s-title-head .wizzy-collection-count"
        );
        collectionHeader.textContent =
          wizzyData.SEARCH_CACHE.cached.searchedResponse.total + " Choices";
        // localStorage.set("collection-count",data.data.response.payload.total);
      }

      // console.log(wizzyData.SEARCH_CACHE.cached.searchedResponse.total);

      const swiperContainers = document.querySelectorAll(".mySwiper");
      swiperContainers.forEach((container) => {
        let swiperInstance = null;

        container.addEventListener("mouseover", () => {
          if (!swiperInstance) {
            swiperInstance = new Swiper(container, {
              loop: true,
              speed: 600,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
              },
            });
          } else {
            swiperInstance.autoplay.start();
          }
        });

        container.addEventListener("mouseleave", () => {
          if (swiperInstance) {
            swiperInstance.autoplay.stop();
            swiperInstance.slideTo(0, 1000);
          }
        });
      });

      // const allImageContainer = document.querySelectorAll(".t4s-product-img");
      //  allImageContainer.forEach((imageContainer) => {
      //    const image1 = imageContainer.querySelector(".t4s-product-main-img");
      //    const image2 = imageContainer.querySelector(".t4s-product-hover-img");
      //    imageContainer.addEventListener("mouseenter", () => {
      //      image1.style.transform = "translateX(-100%)";
      //      image2.style.transform = "translateX(0)";
      //    });
      //    imageContainer.addEventListener("mouseleave", () => {
      //      image1.style.transform = "translateX(0)";
      //   image2.style.transform = "translateX(100%)";
      //    });
      //  });
      return payload;
    }
  );

  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-search-wrapper");
  changeTemplate("wizzy-autocomplete-topproducts");
  changeTemplate("wizzy-facet-block");
  changeTemplate("wizzy-search-empty-results");
};

const changeTemplate = function (div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;
  oldDiv.text = newDiv;
};

window.addEventListener("popstate", function (event) {
  if (
    window.location.href.startsWith(
      "https://libertyshoes-online.myshopify.com/collections"
    )
  ) {
    const collectionHeading = document.querySelector(
      ".page_collection_heading"
    );
    collectionHeading.classList.remove("wizzy-hide-collection-heading");
  }

  const allImageContainer = document.querySelectorAll(".t4s-product-img");
  // console.log(allImageContainer)
  allImageContainer.forEach((imageContainer) => {
    const image1 = imageContainer.querySelector(".t4s-product-main-img");
    const image2 = imageContainer.querySelector(".t4s-product-hover-img");
    imageContainer.addEventListener("mouseenter", () => {
      image1.style.transform = "translateX(-100%)";
      image2.style.transform = "translateX(0)";
    });
    imageContainer.addEventListener("mouseleave", () => {
      image1.style.transform = "translateX(0)";
      image2.style.transform = "translateX(100%)";
    });
  });
});

window.addEventListener("scroll", function () {
  const navbar = document.querySelector("header#shopify-section-header-inline");
  const autocomplete = document.querySelector(".wizzy-autocomplete-wrapper");
  const navbarTop = navbar.getBoundingClientRect().bottom;

  autocomplete.style.setProperty("top", `${navbarTop}px`, "important");
});

window.addEventListener("click", function () {
  const navbar = document.querySelector("header#shopify-section-header-inline");
  const autocomplete = document.querySelector(".wizzy-autocomplete-wrapper");
  const navbarTop = navbar.getBoundingClientRect().bottom;

  autocomplete.style.setProperty("top", `${navbarTop}px`, "important");
});

(function initWizzyAtcPopup() {
  let activeProduct = null;

  function ensurePopup() {
    if (document.querySelector(".wizzy-size-popup-overlay")) return;

    document.body.insertAdjacentHTML(
      "beforeend",
      `
      <div class="wizzy-size-popup-overlay size-popup-overlay" aria-hidden="true">
        <div class="size-popup-box">
          <div class="size-popup-header">
            <div>
              <h3>Select Size</h3>
              <p class="wizzy-size-popup-product-name"></p>
            </div>
            <button type="button" class="size-popup-close wizzy-size-popup-close" aria-label="Close">&times;</button>
          </div>
          <div class="size-popup-content wizzy-size-popup-content"></div>
        </div>
      </div>
    `
    );
  }

  function getPopup() {
    ensurePopup();
    return document.querySelector(".wizzy-size-popup-overlay");
  }

  function closePopup() {
    const popup = getPopup();
    popup.classList.remove("active");
    popup.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    activeProduct = null;
  }

  function isColorSwatchGroup(groupEl) {
    const key = (groupEl.getAttribute("data-swatchkey") || "").toLowerCase();
    const className = (groupEl.className || "").toLowerCase();
    return (
      key.indexOf("color") !== -1 ||
      key.indexOf("colour") !== -1 ||
      className.indexOf("product_color") !== -1 ||
      className.indexOf("product-color") !== -1
    );
  }

  function findSizeSwatchGroup(productEl) {
    const roots = [
      productEl.querySelector(".wizzy-atc-sizes"),
      productEl.querySelector(".size-view-btn"),
      productEl,
    ].filter(Boolean);

    const selectors = [
      ".swatch-group-sizes",
      '[data-swatchkey="sizes"]',
      '[data-swatchkey="size"]',
      ".swatch-group-size",
    ];

    for (let i = 0; i < roots.length; i++) {
      const root = roots[i];
      for (let j = 0; j < selectors.length; j++) {
        const group = root.querySelector(selectors[j]);
        if (group) return group;
      }

      const primaryGroup = root.querySelector(".swatch-group-primary");
      if (primaryGroup && !isColorSwatchGroup(primaryGroup)) {
        return primaryGroup;
      }

      const groups = root.querySelectorAll(".product-item-swatch-group");
      for (let k = 0; k < groups.length; k++) {
        if (!isColorSwatchGroup(groups[k])) return groups[k];
      }
    }

    return null;
  }

  function getSwatchLabel(item) {
    const labelEl = item.querySelector(
      ".wizzy-facet-swatch-individual-value, .wizzy-facet-swatch-value"
    );
    return (
      (item.getAttribute("title") || "").trim() ||
      (labelEl ? labelEl.textContent : "").trim()
    );
  }

  function getSizeSwatches(productEl) {
    const sizeGroup = findSizeSwatchGroup(productEl);
    if (!sizeGroup) return [];

    const items = Array.from(
      sizeGroup.querySelectorAll(".product-item-swatch-item")
    );
    const hasInStockFlags = items.some(function (item) {
      return item.classList.contains("swatch-in-stock");
    });

    return items
      .map(function (item) {
        return {
          variationId:
            item.getAttribute("data-variationid") ||
            item.getAttribute("data-variationId"),
          label: getSwatchLabel(item),
          inStock:
            !hasInStockFlags ||
            item.classList.contains("swatch-in-stock"),
        };
      })
      .filter(function (size) {
        return size.variationId;
      });
  }

  function getCartSections() {
    const configs = window.T4Sconfigs || {};
    const pageType = window.T4Srequest && window.T4Srequest.page_type;

    if (pageType === "cart") {
      return "cart_data," + (window.cartT4SectionID || "");
    }

    if (configs.cartType === "disable") {
      return "cart_data";
    }

    return "cart_data,mini_cart";
  }

  function parseVariantId(variantId) {
    const parsed = parseInt(String(variantId).replace(/[^0-9]/g, ""), 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  function addVariantToCart(variantId, triggerBtn) {
    const parsedId = parseVariantId(variantId);
    if (!parsedId) {
      return Promise.reject(new Error("Invalid variant id"));
    }

    const cartAddUrl =
      (window.T4Sroutes && window.T4Sroutes.cart_add_url
        ? window.T4Sroutes.cart_add_url
        : "/cart/add") + ".js";
    const sections = getCartSections();
    const $ = window.jQuery;

    if (triggerBtn) {
      triggerBtn.classList.add("is--loading");
      triggerBtn.setAttribute("aria-disabled", "true");
    }

    return fetch(cartAddUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        items: [{ id: parsedId, quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          if ($) {
            $(document).trigger("cart:updated", ["error"]);
          }
          if (window.T4SThemeSP && window.T4SThemeSP.Notices) {
            window.T4SThemeSP.Notices(
              data.description || "Could not add product to cart"
            );
          }
          throw new Error(data.description || "Could not add product to cart");
        }

        window.T4SThemeSP = window.T4SThemeSP || {};
        window.T4SThemeSP.isATCSuccess = true;

        if ($) {
          $(document).trigger("add:cart:success").trigger("add:cart:upsell");
        }

        if (data.sections && window.T4SThemeSP.Cart) {
          if (typeof window.T4SThemeSP.Cart.renderContents === "function") {
            window.T4SThemeSP.Cart.renderContents(data.sections);
          } else if (typeof window.T4SThemeSP.Cart.getToFetch === "function") {
            window.T4SThemeSP.Cart.getToFetch();
          }
        }

        return data;
      })
      .finally(function () {
        if (triggerBtn) {
          triggerBtn.classList.remove("is--loading");
          triggerBtn.removeAttribute("aria-disabled");
        }
      });
  }

  function openPopup(productEl, triggerBtn, sizes) {
    const popup = getPopup();
    const popupContent = popup.querySelector(".wizzy-size-popup-content");
    const productNameEl = popup.querySelector(".wizzy-size-popup-product-name");
    const productName =
      productEl.querySelector(".t4s-product-title a")?.textContent?.trim() ||
      productEl.getAttribute("title") ||
      "";

    activeProduct = productEl;
    popupContent.innerHTML = '<div class="wizzy-size-popup-list"></div>';
    const list = popupContent.querySelector(".wizzy-size-popup-list");

    sizes.forEach(function (size) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "wizzy-size-popup-item";
      btn.textContent = size.label || size.variationId;
      btn.disabled = !size.inStock;

      if (!size.inStock) {
        btn.classList.add("is--soldout");
      }

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (!size.inStock || !size.variationId) return;

        btn.classList.add("is--loading");
        btn.disabled = true;

        addVariantToCart(size.variationId, triggerBtn)
          .then(function () {
            closePopup();
          })
          .catch(function () {
            btn.classList.remove("is--loading");
            btn.disabled = !size.inStock;
          });
      });

      list.appendChild(btn);
    });

    if (productNameEl) productNameEl.textContent = productName;
    popup.classList.add("active");
    popup.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function handleAtcClick(e) {
    const triggerBtn = e.target.closest(".wizzy-atc-trigger");
    if (!triggerBtn) return;

    const productEl = triggerBtn.closest(".wizzy-result-product");
    if (!productEl) return;

    e.preventDefault();
    e.stopPropagation();

    const sizes = getSizeSwatches(productEl);

    if (!sizes.length) {
      const fallbackId = productEl.getAttribute("data-id");
      if (fallbackId) addVariantToCart(fallbackId, triggerBtn);
      return;
    }

    // if (sizes.length === 1) {
    //   addVariantToCart(sizes[0].variationId, triggerBtn).catch(function () {});
    //   return;
    // }

    openPopup(productEl, triggerBtn, sizes);
  }

  document.addEventListener("click", handleAtcClick, true);

  document.addEventListener("click", function (e) {
    const popup = document.querySelector(".wizzy-size-popup-overlay");
    if (!popup || !popup.classList.contains("active")) return;

    if (
      e.target.classList.contains("wizzy-size-popup-overlay") ||
      e.target.classList.contains("wizzy-size-popup-close")
    ) {
      closePopup();
    }
  });
})();

// });

